/**
 * Rating (starts) component
 *
 * ## Ussage
 *
 * <rating [value]="4"></rating>
 *
 * ## Output sample
 * <rating [value]="3.5">
 *   <i class="rate-full"></i>
 *   <i class="rate-full"></i>
 *   <i class="rate-full"></i>
 *   <i class="rate-half"></i>
 *   <i class="rate-empty"></i>
 * </rating>
 *
 */

import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, SimpleChanges } from '@angular/core';
import { RatingComponentDef } from '@df/ui/common/rating.component.def';
import { TranslationService } from '@df/ui/translation/translation.service';

@Component({
    selector: 'rating',
    template: `
        @for (item of items; track $index) {
            <i
                [ngClass]="{
                    'rate-empty': item >= maxHalf,
                    'rate-half': item < maxHalf && item >= maxFull,
                    'rate-full': item < maxFull
                }"
                aria-hidden="true"
            ></i>
        }
    `,
    host: {
        '[attr.aria-label]': 'ariaLabel'
    },
    standalone: true,
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingComponent extends RatingComponentDef {
    ariaLabel = '';
    protected override asyncCd = false;
    protected translationService = inject(TranslationService);

    override ngOnChanges(changes: SimpleChanges): void {
        if (changes['value']) {
            this.updateAriaLabel();
        }

        super.ngOnChanges(changes);
    }

    private updateAriaLabel() {
        this.ariaLabel = `${this.translationService.transform('Rating %', this.value || 0)}`;
    }
}
